module.exports = {
    Logger: function Logger() {
        return {
            error: (message) => console.error(message),
        }
    },
}
